import { render, staticRenderFns } from "./automation-list-item.vue?vue&type=template&id=09ddb79e&scoped=true"
import script from "./automation-list-item.vue?vue&type=script&lang=js"
export * from "./automation-list-item.vue?vue&type=script&lang=js"
import style0 from "./automation-list-item.vue?vue&type=style&index=0&id=09ddb79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ddb79e",
  null
  
)

export default component.exports